<template>
  <div class="SaleDashboardViewContainer">
    <nut-row class="leftCenter wbg pd12 box brd8">
      <img :src="user?.avatar" class="sqr50 brd40">
      <div class="colFlex pl12 box">
        <nut-row class="leftCenter">
          <span class="ft14 boldFont">{{ user.realName ? user.realName : user.nickName }}</span>
          <nut-icon name="refresh2" size="12" class="ml8" color="#005FF5" @click="switchUser" v-if="isAdmin"></nut-icon>
        </nut-row>
        <nut-row class="ft12 leftCenter" v-if="user.agent">
          <span>账户余额:￥{{ balance.toFixed(2) }}</span>
        </nut-row>
        <nut-row class="ft12 leftCenter" v-if="user.agent">
          <span class="lightText">待&nbsp;&nbsp;结&nbsp;&nbsp;算:￥{{ settle.toFixed(2) }}</span>
          <nut-icon name="ask" size="12" class="ml2" color="gray"
                    @click="showHelp('T+1自动结算')"></nut-icon>
          <span style="color: #005FF5" class="ml16" @click="withdraw">提现</span>
          <span style="color: lightgrey" class="ml16" @click="forgetPassVisible=true"
                v-if="agentId == null">忘记密码</span>
        </nut-row>
        <nut-row class="ft14" v-else>
          <span class="lightText">您还不是销售</span>
          <!--          <span style="color: #005FF5" class="ml8" @click="apply2agent">自助开户</span>-->
        </nut-row>
      </div>
    </nut-row>

    <nut-row class="bothCenter wbg brd8 pd12 box mt12" v-if="user.agent || user.admin">
      <nut-col :span="user.admin?6:8" class="bothCenter colFlex">
        <span class="boldFont">{{ detail?.todayIncomeAmt ? (detail?.todayIncomeAmt / 100).toFixed(1) : 0 }}</span>
        <nut-row class="bothCenter mt6">
          <span class="lightText ft12">今日销售额</span>
          <nut-icon name="ask" size="12" class="ml2" color="gray"
                    @click="showHelp(`今日销售额 = 支付总额￥${(detail?.todayPaidAmt/100.0).toFixed(1)} - 退款总额￥${(detail?.todayRefundAmt/100.0).toFixed(1)}`)"></nut-icon>
        </nut-row>
      </nut-col>
      <nut-col :span="user.admin?6:8" class="bothCenter colFlex">
        <span class="boldFont">{{ detail?.todayOrderCnt ? detail?.todayOrderCnt : 0 }}</span>
        <span class="lightText ft12 mt6">今日订单</span>
      </nut-col>
      <nut-col :span="user.admin?6:8" class="bothCenter colFlex">
        <span class="boldFont">{{ detail.freezeCommission ? toFixed(detail.freezeCommission / 100) : 0 }}</span>
        <nut-row class="bothCenter mt6">
          <span class="lightText ft12">待解冻佣金</span>
          <nut-icon name="ask" size="12" class="ml2" color="gray"
                    @click="showHelp('当前未分账金额')"></nut-icon>
        </nut-row>
      </nut-col>
      <nut-col :span="user.admin?6:8" class="bothCenter colFlex" v-if="user.admin">
        <span class="boldFont">{{ detail?.unShipCnt ? detail?.unShipCnt : 0 }}</span>
        <span class="lightText ft12 mt6">待发货</span>
      </nut-col>
    </nut-row>


    <nut-row class="colFlex wbg brd8 pd12 box mt12" v-if="user.agent || user.admin">
      <nut-radiogroup v-model="reportTime" direction="horizontal" class="mt10" @change="onReportTimeChange">
        <nut-radio shape="button" label="0">累计</nut-radio>
        <nut-radio shape="button" label="1">今日</nut-radio>
        <nut-radio shape="button" label="2">昨日</nut-radio>
        <nut-radio shape="button" label="3">近7日</nut-radio>
        <nut-radio shape="button" label="4">近30日</nut-radio>
        <nut-radio shape="button" label="5">自然月</nut-radio>
        <nut-radio shape="button" label="6">自定义</nut-radio>
      </nut-radiogroup>
      <nut-row class="leftCenter ft12 mr8" v-if="reportTime == '6'">
        <div style="width: 160px;background:#f6f7f9;" class="vpd6 bothCenter brd20"
             @click="beginTimeVisible=true">
          <span>{{ dateBeginStr ? dateBeginStr : '开始时间' }}</span>
        </div>
        <span class="opd4">~</span>
        <div style="width: 160px;background:#f6f7f9;" class="vpd6 bothCenter brd20"
             @click="endTimeVisible=true">
          <span>{{ dateEndStr ? dateEndStr : '结束时间' }}</span>
        </div>
      </nut-row>
    </nut-row>
    <nut-row class="colFlex wbg brd8 pd12 box mt16" v-if="corpBalance">
      <nut-row class=" bothCenter">
        <nut-col :span="6" class="leftCenter">
          <span class="ft16 boldFont">总账数据</span>
        </nut-col>
        <nut-col :span="18" class="rightCenter ft14">
          <span class="lightText ft12">上次更新:{{ corpBalance?.update }}</span>
        </nut-col>
      </nut-row>
      <nut-row class="mt30">
        <nut-col :span="12" class="bothCenter colFlex">
          <span class="boldFont">¥{{ corpBalanceVal('amt_balaval') }}</span>
          <nut-row class="bothCenter mt6">
            <span class="lightText ft12">可用金额</span>
          </nut-row>
        </nut-col>
        <nut-col :span="12" class="bothCenter colFlex">
          <span class="boldFont">¥{{ corpBalanceVal('amt_balfrz') }}</span>
          <nut-row class="bothCenter mt6">
            <span class="lightText ft12">冻结金额</span>
          </nut-row>
        </nut-col>
      </nut-row>
    </nut-row>
    <nut-row class="colFlex wbg brd8 pd12 box mt16" v-if="user.agent">
      <nut-row class="bothCenter">
        <nut-col :span="6" class="leftCenter">
          <span class="ft16 boldFont">经营数据</span>
        </nut-col>
        <nut-col :span="18" class="rightCenter ft14">
          <span class="lightText ft12">上次更新:{{ detail?.report?.updatedTime }}</span>
        </nut-col>
      </nut-row>
      <nut-row class="mt30">
        <nut-col :span="8" class="bothCenter colFlex">
          <span class="boldFont">{{ detail?.report?.orderCnt }}</span>
          <nut-row class="bothCenter mt6">
            <span class="lightText ft12">订单数</span>
            <nut-icon name="ask" size="12" class="ml2" color="gray" @click="showHelp('历史总订单数')"></nut-icon>
          </nut-row>
        </nut-col>
        <nut-col :span="8" class="bothCenter colFlex">
          <span class="boldFont">¥{{ toFixed(detail?.report?.paidAmt / 100) }}</span>
          <nut-row class="bothCenter mt6">
            <span class="lightText ft12">支付金额</span>
            <nut-icon name="ask" size="12" class="ml2" color="gray" @click="showHelp('历史总支付金额')"></nut-icon>
          </nut-row>
        </nut-col>
        <nut-col :span="8" class="bothCenter colFlex">
          <span class="boldFont">¥{{
              detail?.report?.refundAmt ? toFixed(detail?.report?.refundAmt / 100) : 0
            }}</span>
          <nut-row class="bothCenter mt6">
            <span class="lightText ft12">退款金额</span>
          </nut-row>
        </nut-col>
      </nut-row>
      <nut-row class="mt30">
        <nut-col :span="8" class="bothCenter colFlex">
          <span class="boldFont">¥{{ ((detail?.report?.paidAmt - detail?.report?.refundAmt) / 100).toFixed(1) }}</span>
          <nut-row class="bothCenter mt6">
            <span class="lightText ft12">实际销售额</span>
            <nut-icon name="ask" size="12" class="ml2" color="gray" @click="showHelp('支付减去退款')"></nut-icon>
          </nut-row>
        </nut-col>
        <nut-col :span="8" class="bothCenter colFlex">
          <span class="boldFont">{{ ((detail?.report?.refundAmt / detail?.report?.paidAmt) * 100).toFixed(2) }}%</span>
          <nut-row class="bothCenter mt6">
            <span class="lightText ft12">退款占比</span>
            <nut-icon name="ask" size="12" class="ml2" color="gray" @click="showHelp('总退款/总支付*100%')"></nut-icon>
          </nut-row>
        </nut-col>
        <nut-col :span="8" class="bothCenter colFlex">
          <span class="boldFont">¥{{
              detail?.report?.commission ? toFixed(detail?.report?.commission / 100) : 0
            }}</span>
          <nut-row class="bothCenter mt6">
            <span class="lightText ft12">佣金收入</span>
            <nut-icon name="ask" size="12" class="ml2" color="gray" @click="showHelp('个人历史总佣金收入')"></nut-icon>
          </nut-row>
        </nut-col>
      </nut-row>
      <nut-row class="mt30">
        <nut-col :span="8" class="bothCenter colFlex">
          <span class="boldFont">{{ detail?.report?.uniqueOrderPeopleCnt }}</span>
          <nut-row class="bothCenter mt6">
            <span class="lightText ft12">下单人数</span>
            <nut-icon name="ask" size="12" class="ml2" color="gray" @click="showHelp('历史下单唯一人总数')"></nut-icon>
          </nut-row>
        </nut-col>
        <nut-col :span="8" class="bothCenter colFlex">
          <span class="boldFont">¥{{ toFixed(detail?.report?.avgOrderPrice / 100) }}</span>
          <nut-row class="bothCenter mt6">
            <span class="lightText ft12">客单价</span>
            <nut-icon name="ask" size="12" class="ml2" color="gray" @click="showHelp('客单价')"></nut-icon>
          </nut-row>
        </nut-col>
        <nut-col :span="8" class="bothCenter colFlex">
          <span class="boldFont">{{ detail?.report?.totalVisitCount }}</span>
          <nut-row class="bothCenter mt6">
            <span class="lightText ft12">访问次数</span>
            <nut-icon name="ask" size="12" class="ml2" color="gray" @click="showHelp('所有商品的浏览次数')"></nut-icon>
          </nut-row>
        </nut-col>
      </nut-row>
      <nut-row class="mt30" v-if="user?.admin">
        <nut-col :span="8" class="bothCenter colFlex">
          <span class="boldFont">¥{{ toFixed(detail?.report?.commissionOutcome / 100) }}</span>
          <nut-row class="bothCenter mt6">
            <span class="lightText ft12">佣金支出</span>
            <nut-icon name="ask" size="12" class="ml2" color="gray" @click="showHelp('历史总佣金支出')"></nut-icon>
          </nut-row>
        </nut-col>
        <nut-col :span="8" class="bothCenter colFlex">
          <span class="boldFont">{{ toFixed(detail?.report?.repeatOrderRate) }}</span>
          <nut-row class="bothCenter mt6">
            <span class="lightText ft12">复购率</span>
            <nut-icon name="ask" size="12" class="ml2" color="gray"
                      @click="showHelp('购买次数超过2次的唯一人总数')"></nut-icon>
          </nut-row>
        </nut-col>
        <nut-col :span="8" class="bothCenter colFlex">
          <span class="boldFont">{{ detail?.report?.newCustomerCnt }}</span>
          <nut-row class="bothCenter mt6">
            <span class="lightText ft12">新下单人数</span>
            <nut-icon name="ask" size="12" class="ml2" color="gray"
                      @click="showHelp('仅购买1次的唯一人总数')"></nut-icon>
          </nut-row>
        </nut-col>
      </nut-row>
    </nut-row>
    <nut-row class="colFlex bothCenter ft12 lightText mt16">
      <span>以上金额均为四舍五入取整值</span>
      <span>以上数据非实时数据，更新间隔约为2分钟</span>
    </nut-row>

    <nut-row class="colFlex wbg mt12 pd12 box brd8">
      <span>快捷链接：</span>
      <nut-row class="mt12">
        <nut-button shape="rect"
                    @click="$router.push('/refund/audit/list')"
                    size="small" class="brd4">退款审批
        </nut-button>
      </nut-row>
    </nut-row>

    <nut-popup :style="{ padding: '30px 50px',width:'50vw',borderRadius:'10px' }"
               v-model:visible="smsVerifyVisible">
      <nut-row class="colFlex bothCenter">
        <span>短信验证码</span>
        <nut-input placeholder="请输入短信验证码" input-align="center" v-model="smsCode" class="mt16"></nut-input>
        <nut-row class="mt16 bothCenter">
          <nut-button type="primary" style="width: 100px;" @click="submitSmsVerify">确认</nut-button>
        </nut-row>
      </nut-row>
    </nut-popup>

    <nut-popup :style="{ padding: '30px 50px',width:'50vw',borderRadius:'10px' }"
               v-model:visible="forgetPassVisible2">
      <nut-row class="colFlex bothCenter">
        <span>短信验证码</span>
        <nut-input placeholder="请输入短信验证码" input-align="center" v-model="smsCode" class="mt16"></nut-input>
        <nut-row class="mt16 bothCenter">
          <nut-button type="primary" style="width: 100px;" @click="submitResetPayPassSmsVerify">确认</nut-button>
        </nut-row>
      </nut-row>
    </nut-popup>
    <nut-popup :style="{ padding: '30px 50px',width:'50vw',borderRadius:'10px' }"
               v-model:visible="withdrawVisible">
      <nut-row class="colFlex bothCenter">
        <span>提现金额</span>
        <nut-inputnumber v-model="withdrawAmt" class="mt16" step="1" decimal-places="2" max="50000"/>
        <nut-row class="mt16 bothCenter">
          <nut-button type="primary" style="width: 100px;" @click="afterInputWithdraw">确认</nut-button>
        </nut-row>
      </nut-row>
    </nut-popup>

    <nut-popup :style="{ padding: '30px 50px',width:'50vw',borderRadius:'10px' }"
               v-model:visible="forgetPassVisible">
      <nut-row class="colFlex bothCenter">
        <span>银行卡验证</span>
        <nut-input placeholder="请输入绑定的银行卡号" input-align="center" v-model="cardNo" class="mt16"></nut-input>
        <nut-row class="mt16 bothCenter">
          <nut-button type="primary" style="width: 100px;" @click="submitForgetPassword">确认</nut-button>
        </nut-row>
      </nut-row>
    </nut-popup>

    <nut-popup :style="{ padding: '30px 50px',width:'50vw',borderRadius:'10px' }"
               v-model:visible="realNameVisible">
      <nut-row class="colFlex bothCenter">
        <span>确认您的真实姓名</span>
        <nut-input placeholder="请输入真实姓名" input-align="center" v-model="user.realName" class="mt16"></nut-input>
        <nut-row class="mt16 bothCenter">
          <nut-button type="primary" style="width: 100px;" @click="submitRealName4Withdraw">确认</nut-button>
        </nut-row>
      </nut-row>
    </nut-popup>
  </div>

  <nut-picker
      v-model="agentIdObject"
      v-model:visible="agentSelectVisible"
      :columns="agentList"
      title="选择销售"
      :threeDimensional="false"
      @confirm="switchAgentView"
  >
  </nut-picker>

  <nut-datepicker
      title="开始时间选择"
      type="date"
      v-model="dateBegin"
      @confirm="confirmBeginTime"
      :three-dimensional="false"
      v-model:visible="beginTimeVisible"
  ></nut-datepicker>

  <nut-datepicker
      title="结束时间选择"
      v-model="dateEnd"
      type="date"
      :three-dimensional="false"
      @confirm="confirmEndTime"
      v-model:visible="endTimeVisible"
  ></nut-datepicker>


  <nut-tabbar @tab-switch="tabSwitch" style="position: fixed;bottom: 0" v-model:visible="actived">
    <nut-tabbar-item tab-title="首页" icon="home"></nut-tabbar-item>
    <nut-tabbar-item tab-title="订单" icon="category"></nut-tabbar-item>
    <nut-tabbar-item tab-title="我的" icon="my"></nut-tabbar-item>
  </nut-tabbar>
</template>

<script>
import api from "@/api";
import {Toast} from "@nutui/nutui";

export default {
  name: "SaleDashboardView",
  data() {
    return {
      dateBegin: null,
      dateBeginStr: null,
      dateEnd: null,
      dateEndStr: null,
      beginTimeVisible: false,
      endTimeVisible: false,
      reportTime: '0',
      agentId: null,
      agentIdObject: null,
      actived: 2,
      calendar: null,
      calendarVisible: false,
      smsVerifyVisible: false,
      realNameVisible: false,
      detail: {},
      user: {
        avatar: 'https://cdn.qingbeiyuan.cn/39672ee0-4597-1eff-082f-c948d0b2544e.png',
        agent: false,
        agentAccount: false,
      },
      settle: 0,
      balance: 0,
      smsToken: null,
      smsCode: null,
      cardNo: null,
      withdrawAmt: null,
      withdrawMaxAmt: null,
      auto: this.$route.query.auto,
      agentSelectVisible: false,
      forgetPassVisible: false,
      forgetPassVisible2: false,
      withdrawVisible: false,
      isAdmin: false,
      agentList: [],
      today: '',
      resetPayPassToken: '',
      corpBalance: null,
    }
  },
  methods: {
    getCorpBalance() {
      api.getCorpBalance()
          .then(ret => {
            this.corpBalance = ret;
          })
    },
    corpBalanceVal(dk) {
      if (!this.corpBalance) {
        return 0
      }
      return this.corpBalance.data.map(d => parseFloat(d[dk])).reduce((a, b) => a + b, 0).toFixed(2)
    },
    onReportTimeChange() {
      if (this.reportTime != '6') {
        this.init()
      } else if (this.dateBeginStr && this.dateEndStr) {
        this.init()
      }
    },
    confirmBeginTime(a) {
      this.dateBeginStr = a.selectedOptions.slice(0, 3).map((op) => op.text).join('-');
      if (this.dateEndStr) {
        this.init();
      }
    },
    confirmEndTime(a) {
      this.dateEndStr = a.selectedOptions.slice(0, 3).map((op) => op.text).join('-');
      if (this.dateBeginStr) {
        this.init();
      }
    },
    toFixed(n) {
      return n == null ? 0 : n.toFixed(1);
    },
    switchUser() {
      this.agentSelectVisible = true;
    },
    switchAgentView(a) {
      this.agentId = a.selectedValue[0];
      this.init()
    },
    showHelp(m) {
      Toast.text(m)
    },
    apply2agent() {
      if (this.user.phone) {
        api.getOpenLLPAccountLink()
            .then(ret => {
              window.location.href = ret;
            })
      } else {
        this.$router.push('/fill/user/info')
      }
    },
    tabSwitch(item, index) {
      if (index == 0) {
        this.$router.push('/sale/');
      } else if (index == 1) {
        this.$router.push('/sale/agent/order/list');
      } else if (index == 2) {
        this.$router.push('/sale/agent/dashboard');
      }
    },
    submitRealName4Withdraw() {
      api.submitRealName4Withdraw(this.user)
          .then(() => {
            this.realNameVisible = false;
            this.doWithdrawRequest();
          })
    },
    submitSmsVerify() {
      api.submitSmsVerify({
        token: this.smsToken,
        code: this.smsCode,
        amt: this.withdrawAmt,
        proxyId: this.agentId,
      }).then(() => {
        this.smsVerifyVisible = false;
        Toast.success('申请成功，交易处理中');
        this.queryBalance();
      })
    },
    submitForgetPassword() {
      Toast.loading('请稍等...')
      api.submitForgetPassword({
        cardNo: this.cardNo
      }).then(ret => {
        this.resetPayPassToken = ret;
        Toast.hide()
        this.forgetPassVisible = false;
        this.forgetPassVisible2 = true;
      })
    },
    submitResetPayPassSmsVerify() {
      this.forgetPassVisible2 = false;
      api.getPasswordInputToken('setting_password')
          .then(ret => {
            // 以下参数通过服务端获取
            window.lianlianpay.invokePasswordControl({
              /**
               * passwordScene 使用场景
               * setting_password-设置密码
               * change_password-修改密码
               * bind_card_password-换绑卡
               * cashout_password-提现
               * pay_password-支付
               */
              passwordScene: 'setting_password',
              oidPartner: ret.mid, // 商户号
              'userId': ret.userId, // 用户号
              passwordElementToken: ret.token, // 向服务端请求生成的 token
              env: 'production', // 默认 production-生产
              styles: { // 样式集合
                themeColor: '#0E59F0', // 主题颜色（按钮等）
              }
            }, (res) => {
              Toast.loading('请稍等...')
              api.submitResetPayPassSmsVerify({
                password: res.data.password,
                randomKey: res.data.randomKey,
                token: this.resetPayPassToken.token,
                verifyCode: this.smsCode
              }).then(() => {
                Toast.hide()
                this.smsCode = null;
                this.forgetPassVisible = false;
                this.forgetPassVisible2 = false;
                Toast.success('交易已提交')
              })
            })
          })
    },
    withdraw() {
      if (!this.user.realName) {
        this.realNameVisible = true;
        return;
      }
      this.doWithdrawRequest();
    },
    doWithdrawRequest() {
      this.withdrawMaxAmt = `${this.balance.toFixed(2)}`;
      this.withdrawAmt = `${this.balance.toFixed(2)}`;
      if (this.withdrawAmt > 50000) {
        this.withdrawAmt = 50000;
        this.withdrawMaxAmt = 50000;
      }
      this.withdrawVisible = true;
    },
    afterInputWithdraw() {
      this.withdrawVisible = false;
      Toast.loading('请稍等...')
      api.getPasswordToken({
        amount: this.withdrawAmt,
        proxyId: this.agentId,
      }).then(ret => {
        this.startPassword(ret.mchId, ret.userId, ret.token)
      }).finally(() => {
        this.withdrawVisible = false;
      })
    },
    startPassword(mchId, userId, token) {
      // 以下参数通过服务端获取
      window.lianlianpay.invokePasswordControl({
        /**
         * passwordScene 使用场景
         * setting_password-设置密码
         * change_password-修改密码
         * bind_card_password-换绑卡
         * cashout_password-提现
         * pay_password-支付
         */
        passwordScene: 'cashout_password',
        oidPartner: mchId, // 商户号
        'userId': userId, // 用户号
        passwordElementToken: token, // 向服务端请求生成的 token
        env: 'production', // 默认 production-生产
        styles: { // 样式集合
          themeColor: '#0E59F0', // 主题颜色（按钮等）
        }
      }, (res) => {
        this.submitApply(res.data.password, res.data.randomKey)
      })
    },
    submitApply(password, randomKey) {
      api.submitApplyWithdraw({
        amount: this.withdrawAmt,
        password: password,
        randKey: randomKey,
        proxyId: this.agentId,
      }).then(ret => {
        if ('SMS' == ret.msg) {
          this.smsVerifyVisible = true;
          this.smsToken = ret.data;
        } else {
          Toast.success('申请成功，交易处理中');
          this.queryBalance();
        }
      })
    },
    queryBalance() {
      api.queryAccount({
        agentId: this.agentId
      }).then(ret => {
        this.balance = 0;
        for (let r of ret) {
          if (r.acct_type == 'USEROWN_PSETTLE' || r.acct_type == 'MCHOWN_PSETTLE') {
            this.settle = parseFloat(r.amt_balaval) + parseFloat(r.amt_balfrz);
          }
          if (r.acct_type == 'USEROWN_AVAILABLE' || r.acct_type == 'MCHOWN_AVAILABLE') {
            this.balance = parseFloat(r.amt_balaval) + parseFloat(r.amt_balfrz);
          }
        }
      })
    },
    init() {
      this.dateBegin = new Date();
      this.dateEnd = new Date();
      Toast.loading('请稍等...')
      api.getUserInfo({
        agentId: this.agentId
      }).then(ret => {
        this.user = ret;
        this.isAdmin = this.isAdmin || ret.admin;

        if (ret.agent) {
          api.getPersonalAgentReportDetail({
            agentId: this.agentId,
            reportTime: this.reportTime,
            dateBegin: this.dateBeginStr,
            dateEnd: this.dateEndStr,
          }).then(ret => {
            this.detail = ret;
            Toast.hide();
          })
          this.queryBalance();
          this.getCorpBalance();
        } else {
          if (this.auto) {
            this.apply2agent()
          }
        }
      })
      api.getAgentList()
          .then(ret => {
            this.agentList = ret;
          })
    },
    getCurrentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1，并且保证两位数字
      const day = String(now.getDate()).padStart(2, '0'); // 保证两位数字的日期

      const formattedDate = `${year}-${month}-${day}`;
      return formattedDate;
    }
  },
  mounted() {
    this.calendar = this.getCurrentDate();
    this.today = this.getCurrentDate();
    this.init()
    document.title = '个人中心'
  }
}
</script>

<style lang="scss" scoped>
.SaleDashboardViewContainer {
  display: flex;
  flex-direction: column;
  background-color: rgba(222, 222, 222, 0.3);
  padding: 16px;
  min-height: calc(100vh - 32px);
  padding-bottom: 100px;
}
</style>